module.exports = __webpack_public_path__ + "static/media/Script.c082baa3.svg";